import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { LandLineListInterface } from '../../models/land-line-list.interface';
import { SelectedLandLineInterfaceState } from '../../store/state/selected-land-line.state';
import { environment } from '../../../../../environments/environment';
import { LinesService } from '../../../lines/services/lines.service';
import * as FileSaver from 'file-saver';
import { CustomerFilesInterface } from '../../../shared/models/customer-files.interface';
import { LandLineDetailsInterface, landLineOption } from '../../models/land-line-details.interface';

@Component({
  selector: 'app-land-line-details',
  templateUrl: './land-line-details.component.html',
  styleUrls: ['./land-line-details.component.css'],
  standalone: false
})
export class LandLineDetailsComponent implements OnInit {

  constructor(
    private store: Store<any>,
    private linesService: LinesService,
  ) {}

  environment = environment;
  landLine: LandLineListInterface|null = null;
  landLineDetails: LandLineDetailsInterface|null = null;
  filteredOptions: Array<landLineOption>;
  files: Array<CustomerFilesInterface>;
  displayDocumentsBloc = false;

  ngOnInit(): void {
      this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE)).subscribe((response: SelectedLandLineInterfaceState) => {
          if (window.location.href.includes('infos')) {
              if (response.line != null) {
                  this.landLineDetails = null;
                  this.files = [];
                  this.filteredOptions = [];
                  this.displayDocumentsBloc = false;
                  this.landLine = response.line;
                  this.linesService.files(
                      {
                          bucket_slug: environment.data.customerFilesBucketSlug,
                          type_slugs: [
                              environment.data.landlineSubscriptionPurchaseOrderFileTypeSlug,
                              environment.data.customerContractFileTypeSlug,
                              environment.data.landlineSubscriptionKbisFileTypeSlug,
                              environment.data.voucherFileTypeSlug
                          ],
                          extra: this.landLine.phoneNumber
                      }
                  ).subscribe(res => {
                      this.files = res;
                      for (const file of this.files) {
                          if (file.documents.length > 0) {
                              this.displayDocumentsBloc = true;
                          }
                      }
                  });
                  this.linesService.getLandlineDetails(response.line.phoneNumber).subscribe(
                      details => {
                          this.landLineDetails = details;
                          for (const option of details.options) {
                              if (option.displayWeb === true) {
                                  this.filteredOptions.push(option);
                              }
                          }
                      }
                  );
              }
          }
      });
  }

  formatDate(date: string) {
    const explodeDateTime = date.split('-');
    if (explodeDateTime.length === 3) {
      return explodeDateTime[2] + '/' + explodeDateTime[1] + '/' + explodeDateTime[0];
    }
    return date;
  }

    /**
     * @param typeSlug
     */
    getFile(typeSlug: string): any {
        const files = this.files.find(item => item.typeSlug === typeSlug);
        if (files) {
            return files.documents[0];
        }
        return null;
    }

    downloadFile(id: number, filename: string) {
        this.linesService.downloadFileById(id).subscribe(
            response => {
                FileSaver.saveAs(
                    new Blob(
                        [response],
                        {type: 'application/pdf'}
                    ),
                    filename + '.pdf'
                );
            }
        );
    }
}
